export default __webpack_public_path__ + "b195d006795ee1ea139ee33d5fd56587.png";